import { DocumentType } from "../../../api/caseDocuments";

export const DOCUMENT_PANEL_VISIBLE_TYPES: readonly DocumentType[] = [
  DocumentType.INVESTIGATION_REPORT,
  DocumentType.SCN,
  DocumentType.SCN_RESPONSE,
  DocumentType.COMMITTEE_REPORT,
  DocumentType.REASONED_ORDER,
  DocumentType.FMR1,
  DocumentType.LEA_REPORT,
  DocumentType.SAE_REPORT,
  DocumentType.OTHERS,
  DocumentType.CASE_BACKGROUND,
  DocumentType.RECOVERY_SARFAESI,
  DocumentType.RECOVERY_DRT,
  DocumentType.RECOVERY_NCLT,
  DocumentType.RECOVERY_COURT_CASE,
  DocumentType.IO_APPOINTING_AUTH_REVIEW,
];

